import Vue from "vue";
import App from "./App";
import router from "./router/index";
import store from "./store";
import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";
Vue.use(PaperDashboard);

import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
Vue.use(PerfectScrollbar);

import VueMq from 'vue-mq';
Vue.use(VueMq, {
	breakpoints: {
		mobile: 450,
		tablet: 900,
		laptop: 1250,
		desktop: Infinity,
	}
});
new Vue({
	store,
	router,
	render: (h) => h(App),
}).$mount("#app");
